// Реальный бек тут: http://10.230.84.97:9191
// Но там не будет проставлять cookie из-за cors
const {protocol, host} = window.location
let settings

if (process.env.MODE == 'production')
    settings = {
        ADMIN: `${protocol}//${host}/api/v2/admin`,
        AUTH: `${protocol}//${host}/api/v2/auth`,
        BACKEND: `${protocol}//${host}/api/v2`,
        BACKEND_AI: `${protocol}//${host}/api/v2/ai-assistant`,
    }
else
    settings = {
        ADMIN: 'https://ai-assistants.dss-lab.local/api/v2/admin',
        AUTH: 'https://ai-assistants.dss-lab.local/api/v2/auth',
        BACKEND: 'https://ai-assistants.dss-lab.local/api/v2',
        BACKEND_AI: 'https://ai-assistants.dss-lab.local/api/v2/ai-assistant',
    }

export const {
    BACKEND_AI,
    BACKEND,
    ADMIN,
    AUTH,
} = settings
